import React from 'react';

const Footer = props => {
  return (
    <div className="app__footer no-print">
      <a href={'https://omnibiz.com'} target="_blank" rel="noopener noreferrer">
        Powered by <img src="Images/omnibiz_logo.png" alt="" />
      </a>
    </div>
  );
};

export default Footer;
